module.exports = __webpack_public_path__ + "img/4.e0e1d3f8.jpg";